const PLACEHOLDER_IMAGE_URL = '/limitless/global_assets/images/placeholders/placeholder.jpg';

export {
    PLACEHOLDER_IMAGE_URL
};